import {SubscriptionExpireAlert} from "./dashboard/subscription-expire-alert";
import {PickupRequestsRemaining} from "./dashboard/pickup-requests-remaining";
import moment from "moment-timezone";
import {MyBins} from "./dashboard/my-bins";
import {MyPickupRequests} from "./dashboard/my-pickup-requests";
import * as React from "react";
import {filter} from 'lodash'
import {View} from 'react-native'
import {Button} from "../../../shared/button";
import {Text} from "@ui-kitten/components";
import {Alert} from "../../../shared/alert";

export const Dashboard = ({
    bins,
    pickupRequests,
    subscriptionExpiresIn,
    onAskPickup,
    onBuyAdditionalBin,
    onRenew,
    onCancelPickupRequest
}) => {
    const startDate = moment(`${moment().format('YYYY-MM')}-01`)
    const endDate = moment(startDate).add(1, 'month')
    const usedPickupRequests = filter(pickupRequests, item => moment(item.date).add(1, 'second').isBetween(startDate, endDate)).length
    const remainingPickupRequests = 2 - usedPickupRequests

    const nbOnSite = filter(bins, bin => bin.status === 'on_site').length
    const nbInDelivery = filter(bins, bin => bin.status !== 'on_site').length

    return <View style={{padding: 10, marginBottom: 40}}>
        {!nbOnSite && <View style={{marginTop: 30}}>
            <Alert>
                <View style={{alignItems: 'center', justifyContent: 'center'}}>
                    <Text style={{fontWeight: 'bold', color: '#a0ca45', textAlign: 'center'}}>Thanks for subscribing</Text><Text style={{color: 'white', textAlign: 'center'}}>your bin is on its way</Text>
                </View>
            </Alert>
        </View>}

        <SubscriptionExpireAlert remainingDays={subscriptionExpiresIn} onRenew={onRenew}/>
        <View style={{padding: 40 }}>
            <PickupRequestsRemaining nbAvailableThisMonth={remainingPickupRequests} onAskPickup={onAskPickup} />
            <MyBins nbOnSite={nbOnSite} nbInDelivery={nbInDelivery} onBuyAdditional={onBuyAdditionalBin} />
            <MyPickupRequests items={pickupRequests} onCancelItem={onCancelPickupRequest} />
        </View>
    </View>
}